<template>
    <div id="root" classname="kaxsdc" data-event="load">
        <header id="header" class="header--public header--dark header">
            <div class="container-fluid">
                <div class="d-flex align-items-center justify-content-between flex-lg-nowrap"><span
                        class="d-none d-md-block col-1"></span>
                    <div class="d-block header__brand">
                        <a @click="navigate('/home')" class="d-flex">
                            <img src="@/assets/img/logo-white.png" style="width:98px;">
                        </a>
                    </div>
                    <div class="d-flex align-items-center header__content">
                        <div class="dropdown language-dropdown mr-4">
                            <div class="dropdown-toggle" aria-haspopup="true" aria-expanded="false">
                                <svg viewBox="0 0 24 24" class="icon mr-3 d-none d-lg-block">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M12 2C12.5523 2 13 2.44772 13 3V14.5858L17.2929 10.2929C17.6834 9.90237 18.3166 9.90237 18.7071 10.2929C19.0976 10.6834 19.0976 11.3166 18.7071 11.7071L12.7071 17.7071C12.3166 18.0976 11.6834 18.0976 11.2929 17.7071L5.29289 11.7071C4.90237 11.3166 4.90237 10.6834 5.29289 10.2929C5.68342 9.90237 6.31658 9.90237 6.70711 10.2929L11 14.5858V3C11 2.44772 11.4477 2 12 2ZM2 21C2 20.4477 2.44772 20 3 20H21C21.5523 20 22 20.4477 22 21C22 21.5523 21.5523 22 21 22H3C2.44772 22 2 21.5523 2 21Z"></path>
                                </svg>
                                Download app
                            </div>
                        </div>
                        <div class="dropdown language-dropdown">
                            <div class="dropdown-toggle" aria-haspopup="true" aria-expanded="false">EN</div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <div class="content content--no-navigation">
            <div class="u-ovh">
                <div class="row justify-content-center">
                    <div class="row col-12">

                        <div class="col-lg-6 p-0">
                            <div
                                    class="slick-slider login-gradient-bg mb-0 position-fixed  m-4 d-none d-lg-flex flex-column justify-content-center login__slider-wrapper slick-initialized"

                            >
                                <van-swipe
                                        class="login-swipe"
                                        :autoplay="4000"
                                        :loop="true"
                                        :show-indicators="false"
                                        @change="onChange"
                                >
                                    <van-swipe-item v-for="(item, i) in slides" :key="i">
                                        <div class="d-flex justify-content-center flex-column align-items-center h-100">
                                            <img :src="item.logo" :alt="item.alt" class="login__logo"/>
                                            <div class="text-center p-0 m-0 slide__text-wrapper">
                                                <h1 class="mb-4 font-weight--bold slide__title">{{ item.title }}</h1>
                                                <div class="mx-auto slide__description-wrapper">
                                                    <p class="font-weight--regular mb-5 slide__description">{{ item.desc
                                                        }}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </van-swipe-item>
                                </van-swipe>

                                <!-- 指示器：保持你原来的 slick-dots 结构 -->
                                <ul class="slick-dots" style="display: block;">
                                    <li
                                            v-for="(item, i) in slides"
                                            :key="i"
                                            :class="{ 'slick-active': i === current }"
                                    >
                                        <button @click="goTo(i)">{{ i + 1 }}</button>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div class="col-12 col-sm-10 col-md-8 col-lg-4 offset-sm-1 offset-md-2 offset-lg-1">
                            <section class="section mb-6">
                                <div role="alert">
                                    <div role="presentation" class="alert alert--warning pt-4 collapse-leave">
                                        <div class="alert__header"><span class="alert__icon flex-shrink"><svg
                                                viewBox="0 0 24 24" class="icon icon--24"><path fill-rule="evenodd"
                                                                                                clip-rule="evenodd"
                                                                                                d="M13.8253 3C13.4681 2.3812 12.8078 2 12.0933 2C11.3787 2 10.7185 2.3812 10.3612 3L1.26795 18.75C0.910684 19.3688 0.910684 20.1312 1.26795 20.75C1.62521 21.3688 2.28547 21.75 3 21.75H21.1865C21.9011 21.75 22.5613 21.3688 22.9186 20.75C23.2759 20.1312 23.2759 19.3688 22.9186 18.75L13.8253 3ZM3 19.75L12.0933 4L21.1865 19.75H3ZM13.2002 9C13.2002 8.44772 12.7525 8 12.2002 8C11.6479 8 11.2002 8.44772 11.2002 9V13C11.2002 13.5523 11.6479 14 12.2002 14C12.7525 14 13.2002 13.5523 13.2002 13V9ZM12.2002 16C11.6479 16 11.2002 16.4477 11.2002 17C11.2002 17.5523 11.6479 18 12.2002 18H12.2102C12.7625 18 13.2102 17.5523 13.2102 17C13.2102 16.4477 12.7625 16 12.2102 16H12.2002Z"></path></svg></span>
                                            <div class="alert__title hyphens--manual d-none d-sm-block m-0">Avoid
                                                fraud!
                                            </div>
                                        </div>
                                        <div class="alert__body alert__body--with-icon">
                                            <div class="alert__title hyphens--manual d-block d-sm-none m-0">Avoid
                                                fraud!
                                            </div>
                                            <span class="alert__message">
                                                <div class="text--sm">
                                                    <span>Make sure you're in the correct link: </span>
                                                    <strong><span>trilpayment.com/login</span></strong><span> or </span><strong><span>trilpayment.io/login</span></strong>
                                                </div>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <h1 class="u-my-4">Log in</h1>
                                <div class="d-flex flex-row justify-content-between align-items-start">
                                        <span
                                                class="social-button-mask"></span>
                                    <div class="social-button-container">
                                        <div class="social-button-wrapper">
                                            <button class="btn btn--google" type="button" data-loading="false"
                                                    aria-expanded="false" data-tracking-id="login-button-google"
                                                    data-testid="google-login">
                                                <svg viewBox="0 0 48 48" class="icon">
                                                    <path fill="#FFC107"
                                                          d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"></path>
                                                    <path fill="#FF3D00"
                                                          d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"></path>
                                                    <path fill="#4CAF50"
                                                          d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"></path>
                                                    <path fill="#1976D2"
                                                          d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"></path>
                                                    <text class="invisible">Google Sign up (or login)</text>
                                                </svg>
                                            </button>
                                        </div>
                                        <div id="buttonAnchor" class="social-button-hidden">
                                            <div class="S9gUrf-YoZ4jf" style="position: relative;">
                                                <div></div>
                                                <iframe src="https://accounts.google.com/gsi/button?theme=outline&amp;size=large&amp;shape=pill&amp;text=signin_with&amp;is_fedcm_supported=true&amp;client_id=760831207293-qk6fmck7tt06eb99fu19vdco28em1k91.apps.googleusercontent.com&amp;iframe_id=gsi_112824_221600&amp;cas=Fgix8MZS8H5Mh29YNW1g7npXAnOB2NrALnvlTSLWdf0&amp;hl=en"
                                                        class="L5Fo6c-PQbLGe" allow="identity-credentials-get"
                                                        id="gsi_112824_221600" title="“使用 Google 账号登录”按钮"
                                                        style="display: block; position: relative; top: 0px; left: 0px; height: 44px; width: 204px; border: 0px; margin: -2px -10px;"></iframe>
                                            </div>
                                        </div>
                                    </div>
                                    <span class="social-button-spacer"></span>
                                    <div class="social-button-container">
                                        <div class="social-button-wrapper">
                                            <button class="btn btn--apple" type="button" data-loading="false"
                                                    aria-expanded="false" data-tracking-id="login-button-apple"
                                                    data-testid="apple-login">
                                                <svg viewBox="0 0 24 24" class="icon">
                                                    <path d="M20.8428 17.1447C20.5101 17.9133 20.1163 18.6208 19.66 19.2713C19.0381 20.158 18.5288 20.7719 18.1364 21.1127C17.528 21.6722 16.8762 21.9587 16.1782 21.975C15.6771 21.975 15.0728 21.8324 14.3693 21.5432C13.6636 21.2553 13.015 21.1127 12.422 21.1127C11.8 21.1127 11.133 21.2553 10.4195 21.5432C9.70493 21.8324 9.12928 21.9832 8.68916 21.9981C8.01981 22.0266 7.35264 21.7319 6.68668 21.1127C6.26164 20.742 5.72999 20.1064 5.09309 19.2061C4.40976 18.2446 3.84796 17.1297 3.40784 15.8587C2.93648 14.4857 2.7002 13.1563 2.7002 11.8692C2.7002 10.3948 3.01878 9.12321 3.65689 8.0576C4.1584 7.20166 4.82557 6.52647 5.66059 6.03081C6.49562 5.53514 7.39786 5.28256 8.36949 5.2664C8.90114 5.2664 9.59833 5.43085 10.4647 5.75405C11.3287 6.07834 11.8834 6.24279 12.1266 6.24279C12.3085 6.24279 12.9247 6.0505 13.9694 5.66714C14.9573 5.31162 15.7911 5.16441 16.4742 5.2224C18.3251 5.37178 19.7157 6.10142 20.6405 7.41595C18.9851 8.41896 18.1662 9.82379 18.1825 11.626C18.1975 13.0297 18.7067 14.1979 19.7076 15.1254C20.1611 15.5558 20.6676 15.8885 21.2312 16.1248C21.109 16.4793 20.98 16.8188 20.8428 17.1447ZM16.5978 0.440125C16.5978 1.54038 16.1958 2.56768 15.3946 3.51854C14.4277 4.64892 13.2582 5.30211 11.99 5.19904C11.9738 5.06705 11.9645 4.92812 11.9645 4.78214C11.9645 3.7259 12.4243 2.59552 13.2408 1.67127C13.6485 1.20331 14.167 0.814209 14.7957 0.503814C15.4231 0.19805 16.0166 0.0289566 16.5747 0C16.591 0.147086 16.5978 0.294182 16.5978 0.440111V0.440125Z"></path>
                                                </svg>
                                            </button>
                                        </div>
                                        <div class="social-button-hidden" id="appleid-signin" data-color="black"
                                             data-border-radius="50" data-border="true" data-type="sign-in"
                                             data-width="150" data-height="40">
                                            <div style=" font-synthesis: none; -moz-font-feature-settings: kern; -webkit-font-smoothing: antialiased; -moz-osx-font-smoothing: grayscale; width: 150px; height: 40px; min-width: 130px; max-width: 375px; min-height: 30px; max-height: 64px; position: relative; letter-spacing: initial;"
                                                 role="button" tabindex="0" aria-label="Sign in with Apple">
                                                <div style=" padding-right: 8%; padding-left: 8%; position: absolute; box-sizing: border-box; width: 100%; height: 100%;">
                                                    <svg xmlns="http://www.w3.org/2000/svg"
                                                         style="pointer-events: none; overflow: visible;"
                                                         width="100%" height="100%">
                                                        <g>
                                                            <svg xmlns="http://www.w3.org/2000/svg"
                                                                 style="overflow: visible;" width="100%"
                                                                 height="50%" y="25%" viewBox="0 -11 111.046875 14"
                                                                 fill="#fff">
                                                                <defs>

                                                                </defs>
                                                                <text font-size="12px" textLength="111.046875"
                                                                      font-family="applied-button-font-0"
                                                                      direction="ltr"> Sign in with Apple
                                                                </text>
                                                            </svg>
                                                        </g>
                                                    </svg>
                                                </div>
                                                <div style=" padding: 1px; width: 100%; height: 100%; box-sizing: border-box;">
                                                    <svg xmlns="http://www.w3.org/2000/svg"
                                                         style=" overflow: visible;" width="100%" height="100%">
                                                        <rect width="100%" height="100%" ry="50%" fill="#000"
                                                              stroke="black" stroke-width="1"
                                                              stroke-linecap="round"></rect>
                                                    </svg>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <span class="social-button-mask"></span></div>
                                <hr data-text="or">
                                <div class="form-group">
                                    <div class="form-control-styled">
                                        <div class="form-control">
                                            <div class="text--sm form-control__input-label-container">
                                                <label class="form-control__input-label"
                                                       :class="{ 'form-control__input-label--empty': !(data.username || '').length && activeField !== 'email' }"
                                                       for="email">Your email</label>
                                            </div>
                                            <div class="form-control__input-container form-control__input-container--empty">
                                                <input v-model="data.username" @focus="activeField = 'email'"
                                                       @blur="activeField = ''"
                                                       maxlength="255" autocomplete="email" type="email" id="email"
                                                       class="form-control__input" placeholder="example@gmail.com"
                                                       name="" value="">
                                            </div>
                                        </div>
                                        <div class="text--sm form-control__input-helper-text">Enter the email
                                            address associated with your account.
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="form-control">
                                        <div class="text--sm form-control__input-label-container">
                                            <label class="form-control__input-label"
                                                   :class="{ 'form-control__input-label--empty': !(data.password || '').length && activeField !== 'password' }"
                                                   for="password">Password</label>
                                        </div>
                                        <div class="form-control__input-container form-control__input-container--empty"
                                        :class="{ 'form-control__input-container--invalid': isBlock }">
                                            <input v-model="data.password" :type="pwdVisible ? 'text' : 'password'"
                                                   @focus="activeField = 'password'"
                                                   @blur="activeField = ''" autocomplete="new-password"
                                                   type="password" id="password"
                                                   class="form-control__input" placeholder="Enter your password"
                                                   name="" value="">
                                            <div  v-if="isBlock" class="ml-3 form-control__input-error-alert">
                                                <svg viewBox="0 0 24 24" class="icon icon--16">
                                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                                          d="M13.8253 3C13.4681 2.3812 12.8078 2 12.0933 2C11.3787 2 10.7185 2.3812 10.3612 3L1.26795 18.75C0.910684 19.3688 0.910684 20.1312 1.26795 20.75C1.62521 21.3688 2.28547 21.75 3 21.75H21.1865C21.9011 21.75 22.5613 21.3688 22.9186 20.75C23.2759 20.1312 23.2759 19.3688 22.9186 18.75L13.8253 3ZM3 19.75L12.0933 4L21.1865 19.75H3ZM13.2002 9C13.2002 8.44772 12.7525 8 12.2002 8C11.6479 8 11.2002 8.44772 11.2002 9V13C11.2002 13.5523 11.6479 14 12.2002 14C12.7525 14 13.2002 13.5523 13.2002 13V9ZM12.2002 16C11.6479 16 11.2002 16.4477 11.2002 17C11.2002 17.5523 11.6479 18 12.2002 18H12.2102C12.7625 18 13.2102 17.5523 13.2102 17C13.2102 16.4477 12.7625 16 12.2102 16H12.2002Z"></path>
                                                </svg>
                                            </div>
                                            <div class="ml-3 form-control__input-addon">
                                                <button @click="pwdVisible = !pwdVisible"
                                                        class="btn--icon btn--icon--primary btn--icon--sm"
                                                        type="button" tabindex="-1">
                                                    <svg v-if="!pwdVisible" viewBox="0 0 24 24"
                                                         class="icon icon--24">
                                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                                              d="M2.29331 2.29289C2.68383 1.90237 3.317 1.90237 3.70752 2.29289L7.34625 5.93162C7.40455 5.97793 7.45837 6.03139 7.50637 6.09174L17.8974 16.4828C17.9652 16.5347 18.0272 16.5962 18.0813 16.6667L21.7075 20.2929C22.098 20.6834 22.098 21.3166 21.7075 21.7071C21.317 22.0976 20.6838 22.0976 20.2933 21.7071L17.1396 18.5534C15.6947 19.3988 13.972 20 12.0004 20C9.13874 20 6.80576 18.7353 5.07716 17.2926C3.35091 15.8518 2.16738 14.1857 1.57463 13.2472C1.5668 13.2348 1.55876 13.2221 1.55055 13.2092C1.43291 13.024 1.28018 12.7836 1.20298 12.4467C1.14065 12.1748 1.14067 11.825 1.20303 11.553C1.28028 11.2161 1.43344 10.9751 1.55139 10.7895C1.55967 10.7765 1.56777 10.7637 1.57567 10.7512C2.17804 9.79766 3.40132 8.07525 5.19576 6.60955L2.29331 3.70711C1.90278 3.31658 1.90278 2.68342 2.29331 2.29289ZM6.61828 8.03208C4.97911 9.32619 3.83406 10.921 3.26654 11.8194C3.23105 11.8755 3.20617 11.915 3.18537 11.9492C3.17149 11.9721 3.16235 11.9878 3.15625 11.9988C3.15625 11.9992 3.15625 11.9996 3.15625 12C3.15625 12.0004 3.15625 12.0008 3.15625 12.0012C3.16227 12.012 3.17127 12.0276 3.1849 12.05C3.20556 12.084 3.23029 12.1232 3.26563 12.1792C3.7983 13.0226 4.8524 14.4999 6.35869 15.7571C7.86263 17.0123 9.75708 18 12.0004 18C13.3533 18 14.5778 17.6414 15.6674 17.0812L14.0322 15.446C13.4368 15.7977 12.7418 16 12.0004 16C9.79128 16 8.00042 14.2091 8.00042 12C8.00042 11.2586 8.20271 10.5636 8.55438 9.96818L6.61828 8.03208ZM10.068 11.4818C10.0239 11.647 10.0004 11.8207 10.0004 12C10.0004 13.1046 10.8958 14 12.0004 14C12.1798 14 12.3534 13.9765 12.5186 13.9324L10.068 11.4818ZM12.0004 6C11.6186 6 11.2482 6.02849 10.8892 6.08156C10.3429 6.16234 9.83448 5.78492 9.7537 5.23858C9.67292 4.69223 10.0503 4.18385 10.5967 4.10307C11.0505 4.03597 11.5187 4 12.0004 4C14.8621 4 17.1951 5.26472 18.9237 6.70743C20.6499 8.14818 21.8335 9.81429 22.4262 10.7528C22.434 10.7652 22.4421 10.7779 22.4503 10.7908C22.5679 10.976 22.7207 11.2164 22.7979 11.5533C22.8602 11.8253 22.8602 12.1751 22.7978 12.4471C22.7205 12.7841 22.5671 13.0254 22.449 13.2113C22.4407 13.2243 22.4325 13.2371 22.4246 13.2497C22.1063 13.7536 21.6232 14.4581 20.9832 15.2224C20.6287 15.6459 19.998 15.7017 19.5745 15.3472C19.1511 14.9926 19.0952 14.3619 19.4498 13.9385C20.0211 13.2561 20.4524 12.6267 20.7338 12.1814C20.7694 12.1251 20.7943 12.0855 20.8152 12.0512C20.8292 12.0281 20.8384 12.0122 20.8446 12.0012C20.8446 12.0008 20.8446 12.0004 20.8446 12C20.8446 11.9996 20.8446 11.9992 20.8446 11.9988C20.8386 11.988 20.8296 11.9725 20.8159 11.95C20.7953 11.916 20.7705 11.8768 20.7352 11.8208C20.2025 10.9774 19.1484 9.50007 17.6421 8.24291C16.1382 6.9877 14.2437 6 12.0004 6Z"></path>
                                                    </svg>
                                                    <svg v-else viewBox="0 0 24 24" class="icon icon--24">
                                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                                              d="M6.35868 8.24291C4.85239 9.50007 3.79828 10.9774 3.26562 11.8208C3.23028 11.8768 3.20556 11.916 3.1849 11.95C3.17127 11.9724 3.16227 11.988 3.15625 11.9988C3.15625 11.9992 3.15625 11.9996 3.15625 12C3.15625 12.0004 3.15625 12.0008 3.15625 12.0012C3.16227 12.012 3.17127 12.0276 3.1849 12.05C3.20556 12.084 3.23028 12.1232 3.26562 12.1792C3.79828 13.0226 4.85239 14.4999 6.35868 15.7571C7.86262 17.0123 9.75707 18 12.0004 18C14.2437 18 16.1382 17.0123 17.6421 15.7571C19.1484 14.4999 20.2025 13.0226 20.7352 12.1792C20.7705 12.1232 20.7952 12.084 20.8159 12.05C20.8295 12.0276 20.8385 12.012 20.8446 12.0012C20.8446 12.0008 20.8446 12.0004 20.8446 12C20.8446 11.9996 20.8446 11.9992 20.8446 11.9988C20.8385 11.988 20.8295 11.9724 20.8159 11.95C20.7952 11.916 20.7705 11.8768 20.7352 11.8208C20.2025 10.9774 19.1484 9.50007 17.6421 8.24291C16.1382 6.9877 14.2437 6 12.0004 6C9.75707 6 7.86262 6.9877 6.35868 8.24291ZM5.07715 6.70743C6.80575 5.26472 9.13873 4 12.0004 4C14.8621 4 17.1951 5.26472 18.9237 6.70743C20.6499 8.14818 21.8334 9.81429 22.4262 10.7528C22.434 10.7653 22.4421 10.7779 22.4503 10.7908C22.5679 10.976 22.7206 11.2164 22.7978 11.5532C22.8601 11.8251 22.8601 12.1749 22.7978 12.4468C22.7206 12.7836 22.5679 13.024 22.4503 13.2092C22.4421 13.2221 22.434 13.2347 22.4262 13.2472C21.8334 14.1857 20.6499 15.8518 18.9237 17.2926C17.1951 18.7353 14.8621 20 12.0004 20C9.13873 20 6.80575 18.7353 5.07715 17.2926C3.3509 15.8518 2.16737 14.1857 1.57462 13.2472C1.56679 13.2348 1.55875 13.2221 1.55054 13.2092C1.43292 13.024 1.2802 12.7836 1.203 12.4468C1.14067 12.1749 1.14067 11.8251 1.203 11.5532C1.2802 11.2164 1.43292 10.976 1.55054 10.7908C1.55875 10.7779 1.56679 10.7652 1.57462 10.7528C2.16737 9.81429 3.3509 8.14818 5.07715 6.70743ZM12.0004 10C10.8958 10 10.0004 10.8954 10.0004 12C10.0004 13.1046 10.8958 14 12.0004 14C13.105 14 14.0004 13.1046 14.0004 12C14.0004 10.8954 13.105 10 12.0004 10ZM8.0004 12C8.0004 9.79086 9.79126 8 12.0004 8C14.2095 8 16.0004 9.79086 16.0004 12C16.0004 14.2091 14.2095 16 12.0004 16C9.79126 16 8.0004 14.2091 8.0004 12Z"></path>
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="isBlock" class="text--sm form-control__input-helper-text form-control__input-helper-text--invalid">
                                        Login access denied, please contact support@trilpayment.com.
                                    </div>
                                </div>


                                <div class="" data-testid="captcha"></div>

                                <button class="btn btn--primary btn--block"
                                        :class="{ 'btn--disabled': !canSubmit }"
                                        :disabled="!canSubmit" type="submit"
                                        data-loading="false" aria-expanded="false" id="submit"
                                        data-tracking-id="login-button-submit-form"
                                        data-testid="login-submit-login" @click="submit">Log in
                                </button>
                                <!--                                    <a class="text&#45;&#45;md mt-4" data-testid="forgot-password-login"-->
                                <!--                                       href="/forgot-password">Forgot your password?-->
                                <!--                                    </a>-->
                                <!--                                    <div class="mt-5"><span-->
                                <!--                                            class="text&#45;&#45;md mr-2 text&#45;&#45;base">Not registered yet?</span><a-->
                                <!--                                            class="text&#45;&#45;md mt-5 text&#45;&#45;base" data-testid="create-account-login"-->
                                <!--                                            href="/sign-up">Create an account</a>-->
                                <!--                                    </div>-->
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="d-none">
            <img src="@/assets/img/spacer.gif" referrerpolicy="no-referrer-when-downgrade" alt="spacer">
        </div>
        <div id="spacer"></div>
    </div>
</template>

<script>
    import Vue from "vue";
    import Fetch from "@/utils/fetch";
    import {CountDown, Checkbox} from "vant";

    Vue.use(Checkbox);

    export default {
        name: "login",
        data() {
            return {
                value: "",
                showKeyboard: true,
                showKeyboardz: false,
                lang: this.$i18n.locale || "en_us",
                password: "password",
                show_kefu: false,
                msg_show: true,
                checked: true,
                data: {
                    username: "",
                    password: "",
                },
                current: 0,
                slides: [
                    {
                        logo: require('@/assets/img/fourth-slide-logo.png'),
                        alt: 'fourth-slide',
                        title: 'Open your USA Virtual Account on Trilpay',
                        desc: 'Access a USD account as if you were in the U.S., wherever you are.'
                    },
                    {
                        logo: require('@/assets/img/first-slide-logo.png'),
                        alt: 'first-slide',
                        title: 'Enjoy your Trilpay USD Virtual Card',
                        desc: 'Spend online or in person using your Trilpay balance. Card issued by Lead Bank and managed by Bridge.'
                    },
                    {
                        logo: require('@/assets/img/second-slide-logo.png'),
                        alt: 'second-slide',
                        title: 'Pay, Get Paid, Spend, Earn',
                        desc: 'Exchange dollars, crypto, or your local currency in seconds.'
                    },
                    {
                        logo: require('@/assets/img/third-slide-logo.png'),
                        alt: 'third-slide',
                        title: 'Multiple payment methods',
                        desc: 'Send to banks, payment platforms, crypto wallets, or digital wallets.'
                    }
                ],
                pwdVisible: false,
                activeField: '', // ← 就加这个，记录当前聚焦的字段名
                isBlock: false,
            };
        },
        created() {
            this.data.username = localStorage.getItem("login_username");
            this.data.password = localStorage.getItem("login_password");
            this.$parent.footer("user", false);
        },
        computed: {
            canSubmit() {
                const u = (this.data.username || '').trim()
                const p = (this.data.password || '').trim()
                return u !== '' && p !== ''
            }
        },
        watch: {
            arr(val) {
                this.code = val.join('')
            }
        },
        mounted() {

            var that = this;
            document.body.addEventListener(
                "scroll",
                function () {
                    if (!that.show_kefu) {
                        return;
                    }
                    that.show_kefu = false;
                },
                false
            );
            document.addEventListener(
                "click",
                function (ev) {
                    if (ev.target.className != "kefu_img") {
                        that.show_kefu = false;
                    }
                },
                false
            );
        },
        methods: {
            navigate(path) {
                if (this.$route.path !== path) {
                    this.$router.push(path)
                }
            },
            onChange(index) {
                this.current = index
            },
            goTo(index) {
                this.current = index
                this.$nextTick(() => {
                    this.$refs.swipe && this.$refs.swipe.swipeTo(index)
                })
            },
            Focus(e) {
                console.log(e);
                this.showKeyboard = true;
                this.showKeyboardz = true;
            },
            Blue(e) {
                console.log(e);
                this.showKeyboardz = false;
            },
            sendCode() {
                const phone = '254' + this.data.username
                Fetch("/sms/sendsms", {
                    phone
                })
            },
            kefu_to() {
                if (this.show_kefu) {
                    this.$router.push("/kefu");
                }
                this.show_kefu = !this.show_kefu;
            },
            showPwd() {
                if (this.password == "password") {
                    this.password = "text";
                } else {
                    this.password = "password";
                }
            },
            submit() {
                if (!this.data.username) {
                    this.$toast(this.$t("login.phoneEmpty"));
                    return;
                }

                if (!this.data.password) {
                    this.$toast(this.$t("login.passwordEmpty"));
                    return;
                }

                // var regex = /^[A-Za-z0-9]{1,20}$/;
                // if (!regex.test(this.data.username)) {
                //     this.$toast(this.$t('login.phoneError'));
                //     return;
                // }

                if (this.checked) {
                    localStorage.setItem("login_username", this.data.username);
                    localStorage.setItem("login_password", this.data.password);
                }

                if (!this.checked) {
                    localStorage.removeItem("login_username");
                    localStorage.removeItem("login_password");
                }

                this.isBlock = false;

                Fetch("/index/login", {
                    username: this.data.username,
                    password: this.data.password,
                }).then((res) => {
                    if(res.code == 998) {
                        this.isBlock = true;
                        return;
                    }
                    if (res.data.token) {
                        localStorage.setItem("token", res.data.token);
                        window.dispatchEvent(new Event('loginChange'))
                    }
                    localStorage.removeItem("indexPop");
                    this.$toast({
                        background: "#07c160",
                        message: this.$t("login.signInSuccess"),
                    });

                    this.$router.replace("/home");
                });
            },
        },
    };
</script>

<style lang="less" scoped>
    .back_left {
        position: absolute;
    }

    .login_bg {
        width: 100%;
        height: 310px;
        overflow: hidden;
        /*background-color: #000;*/
        clip-path: ellipse(100% 100% at 50% 0%);
        -webkit-clip-path: ellipse(100% 100% at 50% 0%);
        position: relative;
        z-index: 1;
        padding-top: 15px;

        background: url('~@/assets/images/rectangle.png') no-repeat center center;
        background-size: 100% 100%;

        .language {
            position: absolute;
            top: 40px;
            right: 15px;
            height: 36px;

            img {
                height: 100%;
            }
        }
    }

    /deep/ .van-password-input__security {
        justify-content: space-between;
        align-items: center;
    }

    /deep/ .van-password-input__security li {
        background-color: #f3f3f3;
        width: 30px;
        height: 30px;
        flex: 0.15;
    }

    .hqyzm {
        width: 80%;
        height: 25px;
        margin: 0 auto;
        background: #3f4141;
        border-radius: 10px;
        margin-top: 20px;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        font-weight: bold;
        color: #ffffff;
        line-height: 25px;
        text-align: center;
    }

    .title-img {
        position: absolute;
        top: 70px;
        left: 50%;
        transform: translateX(-50%);

        img {
            height: 45px;
        }
    }

    .basic_wrap {

        //height: 100vh;
        //overflow: hidden;
        //-webkit-overflow-scrolling: touch;
        //background-color: #fff;
        .form {
            margin: -165px auto 0 auto;
            width: 90%;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0px 4px 9px 2px rgba(160, 160, 160, 0.15);
            border-radius: 13px;
            padding: 31px 24px 0 24px;
            position: relative;
            z-index: 2;
        }
    }

    .cut_login {
        //   width: 207px;
        line-height: 25px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 15px;
        text-align: center;
        margin: 0 auto;
        border-radius: 100px;
        overflow: hidden;
        background-color: #f3f3f3;
        color: #c4c5c6;

        a {
            width: 50%;
            // padding: 3px 0;
            // padding-bottom: 10px;
            color: #9e9e9e;
            position: relative;

            // .line {
            //   width: 100%;
            //   height: 1px;
            //   position: absolute;
            //   left: 0;
            //   bottom: 0;
            //   background-color: #f2f2f2;
            // }
        }

        a.cur {
            color: #fff;
            background-color: #00355A;

            .line {
                height: 2px;

                //   background-image: linear-gradient(to right, #f12211, #f18a11);
            }
        }
    }

    .mt {
        margin-top: 20px;
    }

    .item {
        //   border-bottom: 1px solid #f0f1f3;
        font-size: 14px;
        display: flex;
        justify-content: flex-start;
        align-items: flex-end;
        padding-bottom: 4px;

        .icon {
            width: 32px;
            height: 27px;

            img {
                width: 100%;
                height: 100%;
            }
        }

        input {
            background-color: #f3f3f3;
            border-radius: 100px;
            padding: 15px;
            height: 40px;
            margin-left: 7px;
            flex: 1;
            margin-bottom: 3px;
        }
    }

    .item_reset_pwd {
        font-size: 14px;
        color: #5147de;
        text-align: center;
        margin: 20px 0;
        line-height: 60px;
    }

    .van-checkbox {
        margin-top: 20px;
    }

    .reset_pwd {
        color: #0009;
        margin-top: -20px;
        display: block;
    }

    .basic_btn {
        margin: 39px auto 0 auto;
        width: 80% !important;
        background: #0590c8 !important;
        color: #fff;
        font-weight: 700;
        font-size: 16px;
        border-radius: 10px;
    }

    .send {
        margin: 20px auto 0 auto;
        font-size: 14px;
        height: 30px;
        line-height: 30px;
    }

    .kf_tips {
        position: absolute;
        top: 40px;
        right: 18px;
        height: 31px;
        z-index: 9;

        img {
            height: 100%;
        }
    }
</style>
